(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jlib", [], factory);
	else if(typeof exports === 'object')
		exports["jlib"] = factory();
	else
		root["jlib"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 